import React, { useState } from 'react';
import { BringzzButton, BringzzText, BringzzModal } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import { BringzzPageContainer, BringzzIcon } from "@bringzz/components";
import { requestBiometricAuthentication, checkWebAuthnSupport } from 'webauthn';
import useRequest from 'hooks/useRequest';

const AllowFaceId = () => {
    const { backPress, navigate } = useNavigation();
    const { sendRequest, loading } = useRequest();
    const [showModal, setShowModal] = useState(false);

    const handleEnableFaceId = async () => {
        try {
            const response = await sendRequest({
                method: 'POST',
                url: '/module/user/toggleFaceId',
                data: { enable: true }
            });

            if (response?.status === 'success') {
                navigate('/register/employee/activate');
            } else {
                alert('Failed to enable Face ID');
            }
        } catch (error) {
            console.error('Face ID Error:', error);
            alert('Failed to enable Face ID. Please try again.');
        }
    };

    return (
        <>
            <BringzzPageContainer
                className="bg-white relative"
                steps={true}
                activeStep={9}
                header={{
                    left: (
                        <BringzzIcon
                            size='22'
                            icon='IconChevronLeft'
                            folder='LineIcons'
                            className='cursor-pointer'
                            onClick={backPress}
                        />
                    ),
                    title: "Join Us",
                    right: <BringzzButton 
                        size='sm' 
                        className="border border-black" 
                        onClick={() => navigate('/register/employee/activate')}
                    >
                        Skip
                    </BringzzButton>
                }}
                footer={
                    <div className='pb-8 px-6'>
                        <BringzzButton
                            size='lg'
                            className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
                            onClick={() => setShowModal(true)}
                        >
                            Enable Face ID
                        </BringzzButton>
                    </div>
                }
                authenticated={false}
            >
                <div className='relative flex justify-center bg-magic-lilac/20 z-0'>
                    <div className='relative bg-white w-full bg-cover bg-center flex flex-col'>
                        <div className='flex-grow flex flex-col py-8 px-4'>
                            <div className='z-10 flex flex-col'>
                                <div className='pl-2 flex flex-col space-y-6 md:max-w-lg lg:max-w-xl xl:max-w-2xl'>
                                    <BringzzText tag='h1' className='pl-2 text-midnight-blue font-bold'>
                                        Enable Face ID
                                    </BringzzText>
                                    <BringzzText tag="h5" className="font-normal">
                                        Bringzz will use FaceID as an additional safety measure, e.g. before we forward you to the check-out page or to confirm certain setting changes.
                                    </BringzzText>
                                </div>
                                <div className='flex mt-20 flex-col text-center items-center z-0'>
                                    <BringzzIcon
                                        icon="IconMountain"
                                        library="Custom"
                                        className="flex items-center justify-center h-52 w-52 bg-gray-100 rounded-full"
                                        size="110"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </BringzzPageContainer>

            {showModal && (
                <BringzzModal
                    title="Enable Face ID Authentication"
                    description="You'll need to authenticate using your device's biometric sensor to enable this feature."
                    onCancel={() => setShowModal(false)}
                    onConfirm={async () => {
                        try {
                            await handleEnableFaceId();
                        } finally {
                            setShowModal(false);
                        }
                    }}
                    confirmButtonText={loading ? "Authenticating..." : "Continue"}
                    confirmButtonDisabled={loading}
                />
            )}
        </>
    );
};

export default AllowFaceId;